import { render, staticRenderFns } from "./MultiForm.vue?vue&type=template&id=655eddcc&"
import script from "./MultiForm.vue?vue&type=script&lang=js&"
export * from "./MultiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports